<script setup lang="ts">
defineProps<{
  width: string;
  height: string;
}>();
</script>

<template>
  <span class="le-skeleton" aria-hidden="true"></span>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all.less";

@color: @colors[@secondary][200];

.le-skeleton {
  display: inline-block;
  min-width: v-bind("width");
  min-height: v-bind("height");
  animation: pulse 1.2s ease-in-out infinite;
  background-image: linear-gradient(90deg, @color, fade(@color, 45%), @color);
  background-size: 400% 400%;

  @keyframes pulse {
    0% {
      background-position: 0% 0%;
    }

    100% {
      background-position: -135% 0%;
    }
  }
}
</style>
